var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"title":"更换头像","visible":_vm.visible,"width":"440px","custom-class":"dialog","before-close":() => _vm.$emit('hide')}},[_c('avatar-cropper',{ref:"cropper",on:{"ok":_vm.onSubmit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }